import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";
import { Randomnumber } from "../components_root/rendom_number";
export const Save_log_history = async (data) => {
  const { description,logid } = data || {};


  if (!description || !description.trim()) {
    return { success: false, error: "Missing description" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken || sessiontoken === "undefined" || sessiontoken === "null") {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid || guid === "undefined" || guid === "null") {
    return { success: false, error: "Login expired. Please relogin." };
  }

  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {
    // CHECK COMPANY EXISTS
    const companyQuery = query(
      collection(db, "companies"),
      where("companyuid", "==", select_company_uid)
    );
    const companySnap = await getDocs(companyQuery);

    if (companySnap.empty) {
      return { success: false, error: "Company does not exist." };
    }



    const parentDocRef = doc(
      db,
      "companies",
      select_company_uid,
      "log_history",
      logid
    );

    const savequery = {
      ...data,
      queue: Randomnumber(4),
      logid,
      guid,
      companyuid: select_company_uid,
      sessiontoken, 
      date_time: new Date(),
    };
    await setDoc(parentDocRef, savequery);
    return { success: true, message: "Saved successfully." };

  } catch (err) {
    console.error("Error saving voucher:", err);
    return { success: false, error: err?.message || "Unknown error" };
  }
};
